import React from 'react';
import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, withStyles } from '@material-ui/core';

const styles = theme => ({
    buttonDanger: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.error.dark,
        borderRadius: '1px'
    },
    buttonSafe: {
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.success.dark,
        borderRadius: '1px'
    }
});

const VehicleDelete = props => {
    let { classes, deleteModalState, entityName, activeCustomer } = props;

    const handleCloseSafe = () => {
        props.handleDelete();
    }

    const handleCloseDanger = async () => {
        if (deleteModalState.forBulk) {
            await props.bulkDeleteVehicle({ VehicleIDs: deleteModalState.VehicleIDs, ActiveCustomerID: activeCustomer });
            props.handleDelete();
            return;
        }
        await props.onDeleteVehicle({ VehicleID: deleteModalState.VehicleID, ActiveCustomerID: activeCustomer });
        props.handleDelete();
    }

    return (
        <Dialog
            open={deleteModalState.open}
            onClose={handleCloseSafe}
            aria-labelledby="form-dialog-title"
            disableBackdropClick={true}
            disableEscapeKeyDown={false}
            fullWidth={true}
        >
            <DialogTitle id="form-dialog-title">{deleteModalState.forBulk ? 'Bulk delete' : 'Delete'} {entityName}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Be careful when deleting something.<br />
                    Are you sure you want to delete {deleteModalState.forBulk ? 'these' : 'this'} {entityName} data?
          </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleCloseSafe} variant="contained" className={classes.buttonSafe}>
                    No
          </Button>
                <Button onClick={handleCloseDanger} variant="contained" className={classes.buttonDanger}>
                    Yes
          </Button>
            </DialogActions>
        </Dialog>
    );
}

export default withStyles(styles, { withTheme: true })(VehicleDelete);